import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import PageHero from "../components/PageHero";
import SEO from "../components/SEO";
import { api } from "../api";
import { ArrowLeft, FileText, Download } from "lucide-react";

const isPdf = (u) => /\.pdf(\?|$)/i.test(u) || u?.startsWith("data:application/pdf");

const NewsDetail = () => {
  const { id } = useParams();
  const [n, setN] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    api.newsItem(id).then(setN).catch(() => setErr(true));
  }, [id]);

  if (err) {
    return (
      <main className="bg-white min-h-screen">
        <PageHero kicker="Haber" title="Haber bulunamadı" subtitle="Aradığınız içerik kaldırılmış olabilir." />
        <div className="max-w-[900px] mx-auto px-4 md:px-6 pb-24">
          <Link to="/haberler" className="inline-flex items-center gap-2 text-sm font-semibold text-[#1a1a1a] hover:text-[#C9A24B]">
            <ArrowLeft className="w-4 h-4" /> Tüm haberler
          </Link>
        </div>
      </main>
    );
  }

  if (!n) return <main className="pt-32 text-center text-neutral-500">Yükleniyor…</main>;

  return (
    <main className="bg-white">
      <SEO title={n.title} description={n.excerpt} path={`/haberler/${n.id}`} image={n.image} />
      <section className="pt-[110px] md:pt-[140px] pb-8 md:pb-12 bg-white">
        <div className="max-w-[900px] mx-auto px-4 md:px-6">
          <Link to="/haberler" className="inline-flex items-center gap-2 text-xs uppercase tracking-[0.2em] font-semibold text-[#C9A24B] hover:text-[#4E0D1C]">
            <ArrowLeft className="w-3.5 h-3.5" /> Haberler
          </Link>
          <div className="mt-4 text-xs uppercase tracking-[0.2em] text-[#C9A24B] font-semibold">{n.date}</div>
          <h1 className="mt-2 text-3xl md:text-5xl font-black text-[#1a1a1a] leading-[1.1]">{n.title}</h1>
          <p className="mt-5 text-lg text-neutral-600 leading-relaxed">{n.excerpt}</p>
        </div>
      </section>

      <section className="pb-12">
        <div className="max-w-[900px] mx-auto px-4 md:px-6">
          <div className="rounded-2xl overflow-hidden aspect-[16/9] bg-neutral-100">
            <img src={n.image} alt={n.title} className="w-full h-full object-cover" />
          </div>
        </div>
      </section>

      {n.content && (
        <section className="pb-16">
          <div className="max-w-[900px] mx-auto px-4 md:px-6">
            <div
              className="prose prose-neutral max-w-none text-neutral-700 text-[17px] leading-[1.75] whitespace-pre-line"
            >
              {n.content}
            </div>
          </div>
        </section>
      )}

      {n.attachments?.length > 0 && (
        <section className="pb-20">
          <div className="max-w-[900px] mx-auto px-4 md:px-6">
            <h3 className="text-lg font-black text-[#1a1a1a] mb-4">Ekler</h3>
            <div className="grid sm:grid-cols-2 gap-3">
              {n.attachments.map((a, i) => (
                <a
                  key={i}
                  href={a}
                  target="_blank"
                  rel="noreferrer"
                  download
                  className="flex items-center gap-3 p-4 rounded-xl border border-neutral-200 hover:border-[#C9A24B] hover:bg-neutral-50 transition-colors"
                >
                  {isPdf(a) ? (
                    <FileText className="w-6 h-6 text-[#4E0D1C] shrink-0" />
                  ) : (
                    <img src={a} alt="" className="w-10 h-10 rounded object-cover shrink-0" />
                  )}
                  <div className="min-w-0 flex-1">
                    <div className="text-sm font-semibold text-[#1a1a1a] truncate">Ek {i + 1}</div>
                    <div className="text-xs text-neutral-500">{isPdf(a) ? "PDF Dosyası" : "Görsel"}</div>
                  </div>
                  <Download className="w-4 h-4 text-neutral-400" />
                </a>
              ))}
            </div>
          </div>
        </section>
      )}
    </main>
  );
};

export default NewsDetail;
